unit UUser;

interface

uses
  System.SysUtils, WEBLib.Crypto, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.WebCtrls;

type
  TUser = record
    ID : Integer;
    Username : String;
    FirstName : String;
  end;

  TfrmUser = class(TForm)
    divUserOuterContainer: THTMLDiv;
    divUserContainer: THTMLDiv;
    lblComment: TLabel;
    lblDirty: TLabel;
    lblEmptyBack: TLabel;
    lblUserManagement: TLabel;
    lblModified: TLabel;
    btnSave: TButton;
    edtLastName: TEdit;
    edtFirstName: TEdit;
    edtEMail: TEdit;
    mmCustomer: TMemo;
    WebLabel1: TLabel;
    edtMobile: TEdit;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    cbLogistic: TCheckBox;
    cbAdmin: TCheckBox;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormShow(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
    procedure mmCustomerClick(Sender: TObject);
  private
    FNewUser: Boolean;
    FUserID: Integer;
    procedure SetUserID(const Value: Integer);
  protected
    FUser : TJSObject;
    procedure EditToUser;
    procedure UserToEdit;
    procedure UserToCustomer;

    procedure ClearEdits;
    [async] procedure LoadUser; async;
    procedure OpenCustomer;
    [async]procedure SendNewUser; async;
    procedure SendUserUpdate;
  public
    property NewUser : Boolean read FNewUser;
    property UserID : Integer read FUserID write SetUserID;
  protected procedure LoadDFMValues; override; end;

var
  frmUser: TfrmUser;

implementation

uses
  UDatamodule, XData.Web.Client, UErrorHandling, UHelper, UCustomerSelect;

{$R *.dfm}

{ TfrmUser }


procedure TfrmUser.btnSaveClick(Sender: TObject);
begin
  if FNewUser then
    SendNewUser
  else
    SendUserUpdate;
end;

procedure TfrmUser.ClearEdits;
begin
  edtFirstName.Text := '';
  edtLastName.Text := '';
  edtEMail.Text := '';
  edtMobile.Text := '';
  cbLogistic.Checked := false;
  cbAdmin.Checked := false;
  mmCustomer.Clear;
end;



procedure TfrmUser.EditToUser;
var
  Right : Integer;
begin
  FUser.Properties['Vorname'] := edtFirstName.Text;
  FUser.Properties['Nachname'] := edtLastName.Text;
  FUser.Properties['Mobile'] := edtMobile.Text;
  FUser.Properties['EMail'] := edtEMail.Text;

  Right := 0;
  if (cbLogistic.Checked) then
    Right := 1;
  FUser.Properties['LogisticRights'] := Right;

  Right := 0;
  if (cbAdmin.Checked) then
    Right := 1;
  FUser.Properties['AdminRights'] := Right;

end;


procedure TfrmUser.LoadUser;
var
  LResponse: TXDataClientResponse;
  LResponseData: TJSObject;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUsers.GetUser',
        [FUserID])
      );

    if LResponse.StatusCode = 200 then
    begin
      FUser := LResponse.ResultAsObject;
      UserToEdit;
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmUser.mmCustomerClick(Sender: TObject);
begin
  OpenCustomer;
end;


procedure TfrmUser.OpenCustomer;
var
  lform: TfrmCustomerSelect;
begin
  if Assigned(lform) then
  begin
    lform.Close;
  end;
  lform := TfrmCustomerSelect.CreateNew(divUserOuterContainer.ElementID, nil);
  lform.User := FUser;
end;


procedure TfrmUser.SendNewUser;
var
  LResponse: TXDataClientResponse;
begin
  EditToUser;

  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('IUsers.NewUser',
        [UDM.UserID, FUser])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('User added');
    end;

  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;

  Sleep(1);
end;


procedure TfrmUser.SendUserUpdate;
begin

end;


procedure TfrmUser.SetUserID(const Value: Integer);
begin
  FUserID := Value;

  if (FUserID >= 0) then
  begin
    FNewUser := false;

    LoadUser;
  end;
end;


procedure TfrmUser.UserToCustomer;
var
  Customers : TJSArray;
  I: Integer;
  Customer : TJSObject;
begin
  mmCustomer.Clear;

  Customers := TJSArray(FUser.Properties['Kunden']);

  for I := 0 to Customers.Length - 1 do
  begin
    Customer := TJSObject(Customers.Elements[I]);
    mmCustomer.Lines.Add(String(Customer.Properties['Anzeigename']));
  end;
end;


procedure TfrmUser.UserToEdit;
var
  Right : Integer;
begin
  edtFirstName.Text := String(FUser.Properties['Vorname']);
  edtLastName.Text := String(FUser.Properties['Nachname']);
  edtMobile.Text := String(FUser.Properties['Mobile']);
  edtEMail.Text := String(FUser.Properties['EMail']);


  Right := Integer(FUser.Properties['LogisticRights']);
  cbLogistic.Checked := (Right = 1);

  Right := Integer(FUser.Properties['AdminRights']);
  cbAdmin.Checked := (Right = 1);

  UserToCustomer;
end;


procedure TfrmUser.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  FreeAndNil(FUser);

  Action := TCloseAction.caFree;
end;

procedure TfrmUser.WebFormCreate(Sender: TObject);
begin
  FNewUser := true;
  FUserID := -1;

  FUser := TJSObject.new;

  mmCustomer.Clear;
end;


procedure TfrmUser.WebFormShow(Sender: TObject);
begin
  {$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.UserInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
  end;
  {$ENDIF}

  ClearEdits;
end;


procedure TfrmUser.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divUserOuterContainer := THTMLDiv.Create('wcIDUserContent');
  divUserContainer := THTMLDiv.Create('wcIDUserContainer');
  lblComment := TLabel.Create('wcIDCustomer');
  lblDirty := TLabel.Create('wcIDLastName');
  lblEmptyBack := TLabel.Create('wcIDFirstName');
  lblUserManagement := TLabel.Create('wcIDHeading');
  lblModified := TLabel.Create('wcIDEMail');
  WebLabel1 := TLabel.Create('wcIDMobile');
  WebLabel2 := TLabel.Create('wcIDLogistic');
  WebLabel3 := TLabel.Create('wcIDAdmin');
  btnSave := TButton.Create('wcIDSaveUserBtn');
  edtLastName := TEdit.Create('wcIDLastNameInput');
  edtFirstName := TEdit.Create('wcIDFirstNameInput');
  edtEMail := TEdit.Create('wcIDEMailInput');
  mmCustomer := TMemo.Create('wcIDCustomerInput');
  edtMobile := TEdit.Create('wcIDMobileInput');
  cbLogistic := TCheckBox.Create('wcIDLogisticInput');
  cbAdmin := TCheckBox.Create('wcIDAdminInput');

  divUserOuterContainer.BeforeLoadDFMValues;
  divUserContainer.BeforeLoadDFMValues;
  lblComment.BeforeLoadDFMValues;
  lblDirty.BeforeLoadDFMValues;
  lblEmptyBack.BeforeLoadDFMValues;
  lblUserManagement.BeforeLoadDFMValues;
  lblModified.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  edtLastName.BeforeLoadDFMValues;
  edtFirstName.BeforeLoadDFMValues;
  edtEMail.BeforeLoadDFMValues;
  mmCustomer.BeforeLoadDFMValues;
  edtMobile.BeforeLoadDFMValues;
  cbLogistic.BeforeLoadDFMValues;
  cbAdmin.BeforeLoadDFMValues;
  try
    Name := 'frmUser';
    Width := 916;
    Height := 950;
    CSSLibrary := cssBootstrap;
    ElementClassName := 'panels-light-yellow';
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divUserOuterContainer.SetParentComponent(Self);
    divUserOuterContainer.Name := 'divUserOuterContainer';
    divUserOuterContainer.Left := 0;
    divUserOuterContainer.Top := 0;
    divUserOuterContainer.Width := 916;
    divUserOuterContainer.Height := 950;
    divUserOuterContainer.HeightStyle := ssAuto;
    divUserOuterContainer.WidthStyle := ssAuto;
    divUserOuterContainer.Align := alClient;
    divUserOuterContainer.ChildOrder := 1;
    divUserOuterContainer.ElementPosition := epIgnore;
    divUserOuterContainer.ElementFont := efCSS;
    divUserOuterContainer.Role := '';
    divUserContainer.SetParentComponent(divUserOuterContainer);
    divUserContainer.Name := 'divUserContainer';
    divUserContainer.Left := 0;
    divUserContainer.Top := 0;
    divUserContainer.Width := 916;
    divUserContainer.Height := 950;
    divUserContainer.HeightStyle := ssAuto;
    divUserContainer.WidthStyle := ssAuto;
    divUserContainer.Align := alClient;
    divUserContainer.ChildOrder := 31;
    divUserContainer.ElementPosition := epIgnore;
    divUserContainer.ElementFont := efCSS;
    divUserContainer.Role := '';
    lblComment.SetParentComponent(divUserContainer);
    lblComment.Name := 'lblComment';
    lblComment.Left := 67;
    lblComment.Top := 512;
    lblComment.Width := 96;
    lblComment.Height := 35;
    lblComment.Caption := 'Kunden';
    lblComment.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblComment.ElementFont := efCSS;
    lblComment.ElementPosition := epIgnore;
    lblComment.Font.Charset := DEFAULT_CHARSET;
    lblComment.Font.Color := clWindowText;
    lblComment.Font.Height := -29;
    lblComment.Font.Name := 'Tahoma';
    lblComment.Font.Style := [];
    lblComment.HeightStyle := ssAuto;
    lblComment.HeightPercent := 100.000000000000000000;
    lblComment.ParentFont := False;
    lblComment.WidthStyle := ssAuto;
    lblComment.WidthPercent := 100.000000000000000000;
    lblDirty.SetParentComponent(divUserContainer);
    lblDirty.Name := 'lblDirty';
    lblDirty.Left := 67;
    lblDirty.Top := 248;
    lblDirty.Width := 133;
    lblDirty.Height := 35;
    lblDirty.Caption := 'Nachname';
    lblDirty.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblDirty.ElementFont := efCSS;
    lblDirty.ElementPosition := epIgnore;
    lblDirty.Font.Charset := DEFAULT_CHARSET;
    lblDirty.Font.Color := clWindowText;
    lblDirty.Font.Height := -29;
    lblDirty.Font.Name := 'Tahoma';
    lblDirty.Font.Style := [];
    lblDirty.HeightStyle := ssAuto;
    lblDirty.HeightPercent := 100.000000000000000000;
    lblDirty.ParentFont := False;
    lblDirty.WidthStyle := ssAuto;
    lblDirty.WidthPercent := 100.000000000000000000;
    lblEmptyBack.SetParentComponent(divUserContainer);
    lblEmptyBack.Name := 'lblEmptyBack';
    lblEmptyBack.Left := 67;
    lblEmptyBack.Top := 187;
    lblEmptyBack.Width := 113;
    lblEmptyBack.Height := 35;
    lblEmptyBack.Caption := 'Vorname';
    lblEmptyBack.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblEmptyBack.ElementFont := efCSS;
    lblEmptyBack.ElementPosition := epIgnore;
    lblEmptyBack.Font.Charset := DEFAULT_CHARSET;
    lblEmptyBack.Font.Color := clWindowText;
    lblEmptyBack.Font.Height := -29;
    lblEmptyBack.Font.Name := 'Tahoma';
    lblEmptyBack.Font.Style := [];
    lblEmptyBack.HeightStyle := ssAuto;
    lblEmptyBack.HeightPercent := 100.000000000000000000;
    lblEmptyBack.ParentFont := False;
    lblEmptyBack.WidthStyle := ssAuto;
    lblEmptyBack.WidthPercent := 100.000000000000000000;
    lblUserManagement.SetParentComponent(divUserContainer);
    lblUserManagement.Name := 'lblUserManagement';
    lblUserManagement.Left := 259;
    lblUserManagement.Top := 23;
    lblUserManagement.Width := 676;
    lblUserManagement.Height := 58;
    lblUserManagement.AutoSize := False;
    lblUserManagement.Caption := 'Benutzerverwaltung';
    lblUserManagement.ElementClassName := 'control-label col-xl-9 col-lg-9 col-md-7 display-5 mb-5 wcCLLaundryLbl';
    lblUserManagement.ElementFont := efCSS;
    lblUserManagement.ElementPosition := epIgnore;
    lblUserManagement.Font.Charset := DEFAULT_CHARSET;
    lblUserManagement.Font.Color := clWindowText;
    lblUserManagement.Font.Height := -48;
    lblUserManagement.Font.Name := 'Tahoma';
    lblUserManagement.Font.Style := [];
    lblUserManagement.HeightStyle := ssAuto;
    lblUserManagement.HeightPercent := 100.000000000000000000;
    lblUserManagement.ParentFont := False;
    lblUserManagement.WidthStyle := ssAuto;
    lblUserManagement.WidthPercent := 100.000000000000000000;
    lblModified.SetParentComponent(divUserContainer);
    lblModified.Name := 'lblModified';
    lblModified.Left := 67;
    lblModified.Top := 129;
    lblModified.Width := 103;
    lblModified.Height := 35;
    lblModified.Caption := 'E-Mail *';
    lblModified.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    lblModified.ElementFont := efCSS;
    lblModified.ElementPosition := epIgnore;
    lblModified.Font.Charset := DEFAULT_CHARSET;
    lblModified.Font.Color := clWindowText;
    lblModified.Font.Height := -29;
    lblModified.Font.Name := 'Tahoma';
    lblModified.Font.Style := [];
    lblModified.HeightStyle := ssAuto;
    lblModified.HeightPercent := 100.000000000000000000;
    lblModified.ParentFont := False;
    lblModified.WidthStyle := ssAuto;
    lblModified.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(divUserContainer);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 67;
    WebLabel1.Top := 313;
    WebLabel1.Width := 68;
    WebLabel1.Height := 35;
    WebLabel1.Caption := 'Mobil';
    WebLabel1.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epIgnore;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -29;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthStyle := ssAuto;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(divUserContainer);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 67;
    WebLabel2.Top := 377;
    WebLabel2.Width := 195;
    WebLabel2.Height := 35;
    WebLabel2.Caption := 'Logistik-Rechte';
    WebLabel2.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.ElementPosition := epIgnore;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -29;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthStyle := ssAuto;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(divUserContainer);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 67;
    WebLabel3.Top := 441;
    WebLabel3.Width := 178;
    WebLabel3.Height := 35;
    WebLabel3.Caption := 'Admin-Rechte';
    WebLabel3.ElementClassName := 'control-label col-xl-2 col-lg-3 col-md-4 col-sm-5 h5 wcCLUserLbl';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.ElementPosition := epIgnore;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -29;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthStyle := ssAuto;
    WebLabel3.WidthPercent := 100.000000000000000000;
    btnSave.SetParentComponent(divUserContainer);
    btnSave.Name := 'btnSave';
    btnSave.Left := 305;
    btnSave.Top := 881;
    btnSave.Width := 145;
    btnSave.Height := 50;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 25;
    btnSave.ElementClassName := 'btn btn-primary wcCLSaveUserBtn';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epIgnore;
    btnSave.Font.Charset := DEFAULT_CHARSET;
    btnSave.Font.Color := clWindowText;
    btnSave.Font.Height := -19;
    btnSave.Font.Name := 'Tahoma';
    btnSave.Font.Style := [];
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.ParentFont := False;
    btnSave.TabOrder := 9;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    edtLastName.SetParentComponent(divUserContainer);
    edtLastName.Name := 'edtLastName';
    edtLastName.Left := 422;
    edtLastName.Top := 248;
    edtLastName.Width := 322;
    edtLastName.Height := 35;
    edtLastName.ChildOrder := 3;
    edtLastName.ElementClassName := 'form-control';
    edtLastName.ElementFont := efCSS;
    edtLastName.ElementPosition := epIgnore;
    edtLastName.Font.Charset := DEFAULT_CHARSET;
    edtLastName.Font.Color := clWindowText;
    edtLastName.Font.Height := -27;
    edtLastName.Font.Name := 'Tahoma';
    edtLastName.Font.Style := [];
    edtLastName.HeightStyle := ssAuto;
    edtLastName.HeightPercent := 100.000000000000000000;
    edtLastName.ParentFont := False;
    edtLastName.TabOrder := 3;
    edtLastName.WidthStyle := ssAuto;
    edtLastName.WidthPercent := 100.000000000000000000;
    edtFirstName.SetParentComponent(divUserContainer);
    edtFirstName.Name := 'edtFirstName';
    edtFirstName.Left := 422;
    edtFirstName.Top := 187;
    edtFirstName.Width := 322;
    edtFirstName.Height := 35;
    edtFirstName.ChildOrder := 3;
    edtFirstName.ElementClassName := 'form-control';
    edtFirstName.ElementFont := efCSS;
    edtFirstName.ElementPosition := epIgnore;
    edtFirstName.Font.Charset := DEFAULT_CHARSET;
    edtFirstName.Font.Color := clWindowText;
    edtFirstName.Font.Height := -27;
    edtFirstName.Font.Name := 'Tahoma';
    edtFirstName.Font.Style := [];
    edtFirstName.HeightStyle := ssAuto;
    edtFirstName.HeightPercent := 100.000000000000000000;
    edtFirstName.ParentFont := False;
    edtFirstName.TabOrder := 5;
    edtFirstName.WidthStyle := ssAuto;
    edtFirstName.WidthPercent := 100.000000000000000000;
    edtEMail.SetParentComponent(divUserContainer);
    edtEMail.Name := 'edtEMail';
    edtEMail.Left := 422;
    edtEMail.Top := 129;
    edtEMail.Width := 322;
    edtEMail.Height := 35;
    edtEMail.ChildOrder := 3;
    edtEMail.ElementClassName := 'form-control';
    edtEMail.ElementFont := efCSS;
    edtEMail.ElementPosition := epIgnore;
    edtEMail.Font.Charset := DEFAULT_CHARSET;
    edtEMail.Font.Color := clWindowText;
    edtEMail.Font.Height := -27;
    edtEMail.Font.Name := 'Tahoma';
    edtEMail.Font.Style := [];
    edtEMail.HeightStyle := ssAuto;
    edtEMail.HeightPercent := 100.000000000000000000;
    edtEMail.ParentFont := False;
    edtEMail.TabOrder := 7;
    edtEMail.WidthStyle := ssAuto;
    edtEMail.WidthPercent := 100.000000000000000000;
    mmCustomer.SetParentComponent(divUserContainer);
    mmCustomer.Name := 'mmCustomer';
    mmCustomer.Left := 422;
    mmCustomer.Top := 511;
    mmCustomer.Width := 322;
    mmCustomer.Height := 172;
    mmCustomer.ElementClassName := 'form-control wcCLCommentInput';
    mmCustomer.ElementFont := efCSS;
    mmCustomer.ElementPosition := epIgnore;
    mmCustomer.Font.Charset := DEFAULT_CHARSET;
    mmCustomer.Font.Color := clWindowText;
    mmCustomer.Font.Height := -27;
    mmCustomer.Font.Name := 'Tahoma';
    mmCustomer.Font.Style := [];
    mmCustomer.HeightStyle := ssAuto;
    mmCustomer.HeightPercent := 100.000000000000000000;
    mmCustomer.ParentFont := False;
    mmCustomer.ScrollBars := ssVertical;
    mmCustomer.SelLength := 0;
    mmCustomer.SelStart := 0;
    mmCustomer.TabOrder := 6;
    mmCustomer.WidthStyle := ssAuto;
    mmCustomer.WidthPercent := 100.000000000000000000;
    SetEvent(mmCustomer, Self, 'OnClick', 'mmCustomerClick');
    edtMobile.SetParentComponent(divUserContainer);
    edtMobile.Name := 'edtMobile';
    edtMobile.Left := 422;
    edtMobile.Top := 313;
    edtMobile.Width := 322;
    edtMobile.Height := 35;
    edtMobile.ChildOrder := 3;
    edtMobile.ElementClassName := 'form-control';
    edtMobile.ElementFont := efCSS;
    edtMobile.ElementPosition := epIgnore;
    edtMobile.Font.Charset := DEFAULT_CHARSET;
    edtMobile.Font.Color := clWindowText;
    edtMobile.Font.Height := -27;
    edtMobile.Font.Name := 'Tahoma';
    edtMobile.Font.Style := [];
    edtMobile.HeightStyle := ssAuto;
    edtMobile.HeightPercent := 100.000000000000000000;
    edtMobile.ParentFont := False;
    edtMobile.TabOrder := 7;
    edtMobile.WidthStyle := ssAuto;
    edtMobile.WidthPercent := 100.000000000000000000;
    cbLogistic.SetParentComponent(divUserContainer);
    cbLogistic.Name := 'cbLogistic';
    cbLogistic.Left := 422;
    cbLogistic.Top := 383;
    cbLogistic.Width := 28;
    cbLogistic.Height := 35;
    cbLogistic.ChildOrder := 12;
    cbLogistic.ElementClassName := 'custom-control custom-checkbox';
    cbLogistic.ElementButtonClassName := 'custom-control-input';
    cbLogistic.ElementLabelClassName := 'custom-control-label';
    cbLogistic.ElementFont := efCSS;
    cbLogistic.ElementPosition := epIgnore;
    cbLogistic.Font.Charset := DEFAULT_CHARSET;
    cbLogistic.Font.Color := clWindowText;
    cbLogistic.Font.Height := -16;
    cbLogistic.Font.Name := 'Tahoma';
    cbLogistic.Font.Style := [];
    cbLogistic.HeightStyle := ssAuto;
    cbLogistic.HeightPercent := 100.000000000000000000;
    cbLogistic.ParentFont := False;
    cbLogistic.WidthStyle := ssAuto;
    cbLogistic.WidthPercent := 100.000000000000000000;
    cbAdmin.SetParentComponent(divUserContainer);
    cbAdmin.Name := 'cbAdmin';
    cbAdmin.Left := 422;
    cbAdmin.Top := 447;
    cbAdmin.Width := 28;
    cbAdmin.Height := 35;
    cbAdmin.ChildOrder := 12;
    cbAdmin.ElementClassName := 'custom-control custom-checkbox';
    cbAdmin.ElementButtonClassName := 'custom-control-input';
    cbAdmin.ElementLabelClassName := 'custom-control-label';
    cbAdmin.ElementFont := efCSS;
    cbAdmin.ElementPosition := epIgnore;
    cbAdmin.Font.Charset := DEFAULT_CHARSET;
    cbAdmin.Font.Color := clWindowText;
    cbAdmin.Font.Height := -16;
    cbAdmin.Font.Name := 'Tahoma';
    cbAdmin.Font.Style := [];
    cbAdmin.HeightStyle := ssAuto;
    cbAdmin.HeightPercent := 100.000000000000000000;
    cbAdmin.ParentFont := False;
    cbAdmin.WidthStyle := ssAuto;
    cbAdmin.WidthPercent := 100.000000000000000000;
  finally
    divUserOuterContainer.AfterLoadDFMValues;
    divUserContainer.AfterLoadDFMValues;
    lblComment.AfterLoadDFMValues;
    lblDirty.AfterLoadDFMValues;
    lblEmptyBack.AfterLoadDFMValues;
    lblUserManagement.AfterLoadDFMValues;
    lblModified.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    edtLastName.AfterLoadDFMValues;
    edtFirstName.AfterLoadDFMValues;
    edtEMail.AfterLoadDFMValues;
    mmCustomer.AfterLoadDFMValues;
    edtMobile.AfterLoadDFMValues;
    cbLogistic.AfterLoadDFMValues;
    cbAdmin.AfterLoadDFMValues;
  end;
end;

initialization

RegisterClass(TfrmUser);

end.